import type { ExperienceDto } from "@intelligems/ig-types/dtos/experiences";
import { escapeHtml } from "@intelligems/ig-utils/onsite-upsell-template";

export function supportExperiencePrefill(
  params: URLSearchParams
): string | undefined {
  const explicit = params.get("experienceId");
  if (explicit) {
    return explicit;
  }
  const ref = params.get("ref") ?? "";
  try {
    const pathname = new URL(ref, "https://app.intelligems.io").pathname;
    return pathname.match(/^\/(?:experiment|personalization)\/([^/]+)/)?.[1];
  } catch {
    return undefined;
  }
}

export function supportExperienceLabel(
  experience: Pick<ExperienceDto, "name" | "status" | "archivedAtTs" | "id">
): string {
  const status = experience.archivedAtTs
    ? "archived"
    : experience.status === "pending"
      ? "draft"
      : experience.status;
  return `${experience.name} — ${status} (${experience.id.slice(-8)})`;
}

export function supportRequesterName(user: {
  firstName?: string | null;
  lastName?: string | null;
  email: string;
}): string {
  return (
    [user.firstName, user.lastName]
      .map((part) => part?.trim())
      .filter(Boolean)
      .join(" ") || user.email
  );
}

export function supportPlainTextToHtml(value: string): string {
  return `<p>${escapeHtml(value).replace(/\r?\n/g, "<br>")}</p>`;
}
